import {
  IconHeart,
  IconHeartEmpty,
  IconAngleLeft,
} from 'src/Components/shared/Icon'
import {
  useIsFavoritedListing,
  useFavoriteListingClickHandler,
} from 'src/hooks/listings'
import history from 'src/history'
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import useViewport from 'src/hooks/useViewport'
import { defineMessages, useIntl } from 'react-intl'
import { PATH_HELPERS } from 'src/constants/navigation'
import { Button, ActionBar, Text } from 'src/Components'
import { ListingDetailsListing } from 'src/types/listings'
import { selectCustomerId } from 'src/store/selectors/customerProfile'
import ScheduleTourButton from 'src/Components/homeSearch/ListingDetails/ScheduleTour/ScheduleTourButton'

const MSG = defineMessages({
  back: {
    id: 'HomeSearch.listings.actions.back',
    defaultMessage: 'Back',
  },
  more: {
    id: 'HomeSearch.listings.actions.more',
    defaultMessage: 'More Listings',
  },
  favorite: {
    id: 'HomeSearch.listings.actions.favorite',
    defaultMessage: 'Favorite',
  },
})

export interface ListingActionBarProps {
  opacity?: number
  showTourButton?: boolean
  headingComponent?: ReactNode
  listing: ListingDetailsListing
}

export const ListingActionBar = ({
  opacity,
  listing,
  headingComponent,
  showTourButton = false,
}: ListingActionBarProps) => {
  const intl = useIntl()
  const { isLargeOrAbove } = useViewport()
  const customerId = useSelector(selectCustomerId)
  const isFavorite = useIsFavoritedListing(listing)
  const handleFavoriteClick = useFavoriteListingClickHandler()

  const handleBackButtonClick = () => {
    history.location?.key
      ? history.goBack()
      : history.push(
          PATH_HELPERS.listings.buildPath(
            customerId,
            'postal_code',
            listing.address.postalCode
          )
        )
  }

  return (
    <ActionBar opacity={opacity}>
      <ActionBar.Left>
        <Button
          aria-label='back'
          data-qa='buttonBack'
          iconStart={IconAngleLeft}
          onClick={handleBackButtonClick}
        >
          <Text element='span' weight='semibold'>
            {history.location?.key
              ? intl.formatMessage(MSG.back)
              : intl.formatMessage(MSG.more)}
          </Text>
        </Button>
      </ActionBar.Left>
      <ActionBar.Heading>
        {isLargeOrAbove && headingComponent}
      </ActionBar.Heading>
      <ActionBar.Right>
        {(isLargeOrAbove || showTourButton) && <ScheduleTourButton />}
        <Button
          onClick={e => handleFavoriteClick(e, listing)}
          iconStart={isFavorite ? IconHeart : IconHeartEmpty}
        >
          <Text element='span' weight='semibold'>
            {intl.formatMessage(MSG.favorite)}
          </Text>
        </Button>
      </ActionBar.Right>
    </ActionBar>
  )
}
